/**
 * Market helpers (replaces caribe7/lib/helpers/markets).
 */

export function getAvailableMarketTypeIDS(markets: Record<string, { market_type_id: unknown }> | null | undefined) {
  if (markets == null || typeof markets !== 'object') return [];
  return Object.values(markets).map((x) => parseInt(String(x.market_type_id), 10));
}

export function filterAllowedMarketTypes(
  market_types: Record<string, { market_type_id: unknown }> | null | undefined,
  allowed_market_type_ids: number[]
) {
  if (market_types == null || typeof market_types !== 'object') return [];
  return Object.values(market_types).filter((x) =>
    allowed_market_type_ids.includes(parseInt(String(x.market_type_id), 10))
  );
}

export function getMarketTypeByGroupId(
  group_id: number | string,
  selected_event?: { sport_id?: unknown; market_types?: Record<string, Record<string, { market_type_group_id: unknown }>> }
) {
  const { sport_id, market_types = {} } = selected_event || {};
  const types = market_types[String(sport_id)];
  if (!types) return undefined;
  return Object.values(types).find(
    ({ market_type_group_id: gid }) => String(gid) === String(group_id)
  );
}

export function isRacingSport(sport_id: number | string) {
  return [10, 11, 20, 21, 30].includes(parseInt(String(sport_id), 10));
}

export function isFootballSport(sport_id: number | string) {
  return parseInt(String(sport_id), 10) === 50;
}

export function isBaseballSport(sport_id: number | string) {
  return parseInt(String(sport_id), 10) === 40;
}
